import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';

const NotFound: React.FC = () => {
  return (
    <div className="pt-24 min-h-[70vh] flex items-center">
      <Seo
        title="Page not found | Cimmple"
        description="This page does not exist. Return to Cimmple products, pricing, or documentation."
        noIndex
      />
      <section className="w-full py-20">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm font-semibold text-primary-600 dark:text-primary-400 mb-3">404</p>
          <h1 className="text-3xl md:text-4xl font-display font-bold text-slate-900 dark:text-white mb-3">
            Page not found
          </h1>
          <p className="text-slate-600 dark:text-dark-300 mb-8">
            The URL may have changed or been removed. Try the homepage, products, or docs.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/" className="btn-primary inline-flex">
              Go home
            </Link>
            <Link to="/products" className="btn-secondary inline-flex">
              View products
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
